import { Site } from '../interfaces/tenancy';
import axios from 'axios';
import { Envelope } from '../interfaces/envelope';

async function getSites(): Promise<Site[]> {
	try {
		const response = await axios.get<Envelope<Site[]>>(`sites`);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

export const sites = {
	getSites,
};
